/**
 * Created by philipwells on 16/11/2017.
 */

angular.module('qkr').factory('loginService', function loginService($http, $window, appConfigService) {


    function redirectBasedOnRoles(data) {
        const roles = data.roles;
        if (roles) {
            if (roles.indexOf('ROLE_ADMIN') > -1
                || roles.indexOf('ROLE_ACCOUNT_MANAGER') > -1
                || roles.indexOf('ROLE_PARTNER') > -1) {
                $window.location = appConfigService.createUrl('/masterCardAdmin');
            } else if (roles.indexOf('ROLE_MERCHANT_ADMIN') > -1) {
                $window.location = appConfigService.createUrl('/merchantAdmin');
            } else if (roles.indexOf('ROLE_MERCHANT_USER') > -1
                || roles.indexOf('ROLE_DEPARTMENT_MANAGER') > -1) {
                $window.location = appConfigService.createUrl('/app/storeFront');
            } else if (roles.indexOf('ROLE_REPORT_MANAGER') > -1) {
                $window.location = appConfigService.createUrl('/app/reportManager');
            } else {
                $window.location = appConfigService.createUrl('/auth/logout?timeout=true');
            }
        } else {
            $window.location = appConfigService.createUrl('/auth/logout?timeout=true');
        }
        return 'success';
    }

    return {
        login(user) {
            const loginUrl = appConfigService.createUrl('/auth/login');
            return $http.post(loginUrl,
                    {username: user.username, password: user.password})
                .then(response => redirectBasedOnRoles(response.data))
                .catch(response => {
                    throw response.data;
                });
        },
        initIndex() {
            return $http.post(appConfigService.createUrl('/auth/initIndex'), {})
                .then(response => response.data)
                .catch(response => {
                    throw response.data;
                });
        }
    };
});



// WEBPACK FOOTER //
// ./src/services/login.service.js